import styled from 'styled-components';
import { $primaryText } from '../../index';

export const KliLogo = styled.div`
    font-size: ${({ size }) => size || '32px'};
    width: fit-content;
    height: ${({ size }) => size || '32px'};
    color: ${({ color }) => color || $primaryText};
`;
